// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2y3Sm","title":"InfoRow_title__2Vzrj"};